import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  InputAdornment,
  tableCellClasses,
  Paper,
  IconButton,
  Dialog,
} from "@mui/material";
import ClientServices from "services/Client";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { SearchIcon, FontFamily } from "assets";
import SelectField from "components/Select";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { Delete } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { CancelOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToaster } from "components/Toaster";

const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
  },
});

// const useStyles = {
//   tableHeader: {
//     backgroundColor: '#f5f5f5',
//     fontWeight: 'bold',
//   },
//   tableCell: {
//     textAlign: 'center',
//   },
//   notesTextArea: {
//     width: '100%',
//     marginTop: '20px',
//   },
// };

const BookPrepaidAuctionCharges = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVin, setSelectedVin] = useState("");
  const [selectedPaidBy, setSelectedPaidBy] = useState("VBI");
  const [rows, setRows] = useState([]);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    notes: "",
    date: "",
    vehicles: [],
  });
  const {
    register,
    formState: { errors },
    getValues: getValues1,
  } = useForm();
  const [isSearching, setIsSearching] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState(
    location.state?.selectedRows || []
  );
  const [filters, setFilters] = useState({});
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const getAllSLPVehicles = async (page, limit, filter) => {
    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };

      let params = {
        page: Page,
        limit: Limit,
        ...Filter,
      };

      const { data } = await ClientServices.getSLPVehicles(params);

      if (filter?.search) {
        const matchedVehicle = data.vehicles.find(
          (vehicle) => vehicle.vin === filter.search
        );

        if (matchedVehicle) {
          const alreadyExists = rows.find(
            (row) => row.vin === matchedVehicle.vin
          );

          if (!alreadyExists) {
            const isFirstRow = rows.length === 0;
            const isSameBuyer =
              !isFirstRow && rows[0].buyer_id === matchedVehicle.buyer_id;

            if (isFirstRow || isSameBuyer) {
              const newRow = {
                id: matchedVehicle.id,
                customer: matchedVehicle.customer?.name,
                buyer_id: matchedVehicle.buyer_id,
                buyer_name: matchedVehicle.buyer.name,
                vin: matchedVehicle.vin,
                lot: matchedVehicle.lot_number,
                make: matchedVehicle.veh_make?.name || "",
                model: matchedVehicle.veh_model?.name || "",
                shipping_vendor: matchedVehicle?.ship_vendor?.name || "",
                shipping_vendor_id: matchedVehicle?.ship_vendor?.id || "",
                lps: 0,
                stgS: 0,
                courierCharges: 0,
                total: 0,
                paid_by: "",
              };
              setRows([...rows, newRow]);
            } else {
              ErrorToaster(
                "Vehicles with a different buyer ID cannot be added."
              );
            }
          } else {
            ErrorToaster("This VIN is already added.");
          }
        } else {
          ErrorToaster("vehicle is not booked");
        }
      } else {
        setVehicles(data.vehicles);
      }

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllSLPVehicles();
  }, []);

  const handleEditClick = (row) => {
    setSelectedRows(row); // Store the row data
    setOpenEditModal(true); // Open the modal for editing
    setNotes((prev) => ({ ...prev, [row.id]: row.notes || "" })); // Pre-fill the modal with the current note
  };

  const handleNumberInput = (e, id, field, setter) => {
    let value = e.target.value.trim();

    const regex = /^[0-9]*\.?[0-9]{0,2}$/;

    if (regex.test(value)) {
      value = parseFloat(value).toFixed(2);

      // Update the row data with the new value
      setter(id, value);
    }
  };

  const handleLPSChange = (id, value) => {
    // const value = parseFloat(val).toFixed(2)
    const updatedRows = rows.map((row) =>
      row.id === id
        ? { ...row, lps: value, total: value + row.stgS + row.courierCharges }
        : row
    );
    setRows(updatedRows);
  };

  const handleSTGSChange = (id, value) => {
    // const value = parseFloat(val).toFixed(2)
    const updatedRows = rows.map((row) =>
      row.id === id
        ? { ...row, stgS: value, total: row.lps + value + row.courierCharges }
        : row
    );
    setRows(updatedRows);
  };

  const handleCourierChargesChange = (id, value) => {
    // const value = parseFloat(val).toFixed(2)
    const updatedRows = rows.map((row) =>
      row.id === id
        ? { ...row, courierCharges: value, total: row.lps + row.stgS + value }
        : row
    );
    setRows(updatedRows);
  };

  const handleNotesChange = (e) => {
    const { value } = e.target;
    setNotes((prev) => ({
      ...prev,
      [selectedRows.id]: value, // Update the note for the selected row
    }));
  };

  const handleSaveNotes = () => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === selectedRows.id
          ? { ...row, notes: notes[selectedRows.id] } // Update the note for the specific row
          : row
      )
    );
    setOpenEditModal(false);
  };

  const handleDelete = (vin) => {
    const updatedRows = rows.filter((row) => row.vin !== vin);
    setRows(updatedRows);
  };

  const handleSubmit = async () => {
    if (selectedPaidBy?.id === "vendor") {
      const missingShippingVendor = rows.some((row) => !row.shipping_vendor);

      if (missingShippingVendor) {
        ErrorToaster("Shipping vendor is not defined.");
        return;
      }
    }

    const vehiclesData = rows.map((row) => ({
      booking_id: row.id,
      late_payment: row.lps,
      storage: row.stgS,
      courier_charges: row.courierCharges,
      paid_by: selectedPaidBy?.name || "VBI",
      shipping_vendor: row?.shipping_vendor_id,
      notes: row.notes,
    }));

    const finalData = {
      date: formData.date || selectedDate || moment().format("YYYY-MM-DD"),
      vehicles: vehiclesData,
    };

    try {
      setLoading(true);
      const response = await ClientServices.bookPrepaidAuction(finalData);
      navigate("/prepaid-auction-charges-list");

      if (response.success) {
        alert("Data submitted successfully!");
        setRows([]);
        setNotes("");
        setFormData({
          date: "",
          vehicles: [],
        });
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const vinOptions = vehicles.map((item) => ({
    id: item?.vin,
    name: item?.vin,
  }));

  const handleFilter = async (data) => {
    if (!data) {
      return;
    }

    if (isSearching) return;

    setIsSearching(true);
    try {
      await getAllSLPVehicles(1, "", data);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <Fragment>
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "30%",
            height: "auto",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={() => setOpenEditModal(false)}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>
        <Box component={"form"}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
            Notes
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={1}
            value={notes[selectedRows?.id] ?? ""}
            onChange={handleNotesChange}
            placeholder="Enter notes"
          />

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <PrimaryButton title="Submit" onClick={handleSaveNotes} />
          </Box>
        </Box>
      </Dialog>

      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Book - Prepaid Auction Charges
            </Typography>
          </Box>
        </Grid>
        {/* Filters */}
        <Grid item md={11}>
          <Box
            sx={{
              m: "20px 0 20px 0",
              p: "20px",
              bgcolor: Colors.feta,
              border: `1px solid ${Colors.iron}`,
              borderRadius: "9px",
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems={"center"}
              component={"form"}
            >
              <Grid item xs={12} sm={4} sx={{ marginTop: "5px" }}>
                <InputField
                  size={"small"}
                  inputStyle={{ backgroundColor: "#f5f5f5" }}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search")}
                />
                {/* <InputField
                  size={"small"}
                  inputStyle={{ backgroundColor: '#f5f5f5' }}
                  label={'Search Vin'}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                  }}
                  placeholder={"Search"}
                  value={searchTerm}
                  onInput={handleSearchChange}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      const matched = vehicles.find((v) => v.vin === searchTerm);
                      if (matched) {
                        handleVinChange({ id: matched.vin });
                      } else {
                        alert('VIN not found.');
                      }
                    }
                  }}
                
                /> */}

                {/* <SelectField
                  size="small"
                  label={"Select VIN"}
                  options={vinOptions}
                  selected={selectedVin}
                  onSelect={handleVinChange}
                  error={errors?.vin?.message}
                /> */}
              </Grid>
              <Grid item xs={12} sm={4}>
                <DatePicker
                  size={"small"}
                  label={"Select Date"}
                  value={
                    selectedDate ? moment(selectedDate).toDate() : new Date()
                  }
                  onChange={(date) =>
                    setSelectedDate(moment(date).format("YYYY-MM-DD"))
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    mt: "18px",
                  }}
                >
                  <PrimaryButton
                    onClick={() => {
                      const searchVal = getValues1("search");
                      if (searchVal) {
                        handleFilter({ search: searchVal });
                      }
                    }}
                    title="Search"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                borderRadius: 2,
                maxHeight: "calc(100vh - 330px)",
                mt: 2,
              }}
              className="table-box"
            >
              <Table stickyHeader sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <Cell>Customer</Cell>
                    <Cell>VIN</Cell>
                    <Cell>LOT</Cell>
                    <Cell>Model/Make</Cell>
                    <Cell>Shipping Vendor</Cell>
                    <Cell sx={{ width: "10%" }}>LP$</Cell>
                    <Cell sx={{ width: "10%" }}>STG$</Cell>
                    <Cell sx={{ width: "10%" }}>Courier Charges$</Cell>
                    <Cell>Total$</Cell>
                    <Cell>Paid By</Cell>
                    <Cell>Notes</Cell>
                    <Cell>Action</Cell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length > 0 ? (
                    rows.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          bgcolor:
                            rows.indexOf(row) % 2 !== 0 ? "#EFF8E7" : "inherit",
                        }}
                      >
                        <Cell>{row?.customer}</Cell>
                        <Cell>{row.vin}</Cell>
                        <Cell>{row.lot}</Cell>
                        <Cell>
                          {row.model}
                          {"-"}
                          {row.make}
                        </Cell>
                        <Cell>{row?.shipping_vendor ?? "-"}</Cell>
                        <Cell sx={{ width: "10%" }}>
                          <InputField
                            size="small"
                            type="number"
                            value={row.lps}
                            onInput={(e) =>
                              handleLPSChange(
                                row.id,
                                parseFloat(e.target.value)
                              )
                            }
                          />
                        </Cell>
                        <Cell sx={{ width: "10%" }}>
                          <InputField
                            size="small"
                            type="number"
                            value={row.stgS}
                            onInput={(e) =>
                              handleSTGSChange(
                                row.id,
                                parseFloat(e.target.value)
                              )
                            }
                          />
                        </Cell>
                        <Cell sx={{ width: "10%" }}>
                          <InputField
                            size="small"
                            type="number"
                            value={row.courierCharges}
                            onInput={(e) =>
                              handleCourierChargesChange(
                                row.id,
                                parseFloat(e.target.value)
                              )
                            }
                          />
                        </Cell>
                        <Cell>{parseFloat(row.total).toFixed(2)}</Cell>
                        <Cell sx={{ width: "15%" }}>
                          <SelectField
                            size={"small"}
                            placeholder="Paid By"
                            options={[
                              {
                                id: "vendor",
                                name: "Vendor",
                              },
                              {
                                id: "vbi",
                                name: "VBI",
                              },
                            ]}
                            selected={selectedPaidBy}
                            onSelect={(value) => setSelectedPaidBy(value)}
                            error={errors?.paidBy?.message}
                            register={register("paidBy", {
                              required: "Please select Paid By.",
                            })}
                          />
                        </Cell>
                        <Cell>
                          <Box
                            component={"div"}
                            onClick={() => handleEditClick(row)}
                          >
                            <EditIcon />
                          </Box>
                        </Cell>
                        <Cell>
                          {" "}
                          <IconButton
                            onClick={() => handleDelete(row.vin)}
                            color="error"
                          >
                            <Delete />
                          </IconButton>
                        </Cell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <Cell
                        colSpan={11}
                        sx={{
                          textAlign: "center",
                          fontWeight: "bold",
                          fontFamily: FontFamily.NunitoRegular,
                          fontSize: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          No Data Found
                        </Box>
                      </Cell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
        {/* Notes */}
        {/* <Grid item md={11}>
          <Grid item md={4}>
            <InputField
              label={"Add Notes"}
              multiline={true}
              rows={1}
              placeholder={"Notes"}
              value={notes}
              onInput={handleNotesChange}
            />
          </Grid>
        </Grid> */}

        {/* Submit Button */}
        <Grid item md={11} justifyContent="end">
          <Box
            sx={{
              mt: "28px",
              mb: "28px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <PrimaryButton
              onClick={handleSubmit}
              title="Submit"
              loading={loading}
            />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default BookPrepaidAuctionCharges;
